import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OfbizList, RemoteFormData, ColumnFieldTitle, OfbizField } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../../forms';

@Component({
  selector: 'pty-customer-billing-account',
  templateUrl: './customer-billing-account.component.html',
  styleUrls: ['./customer-billing-account.component.scss']
})
export class CustomerBillingAccountComponent implements OnChanges{
  @Input() partyId:string;
//CustomerBillingPaymentMethods
  listForm:OfbizList;
  
  title:"Billing Accounts";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"CustomerBillingPaymentMethods",
        listFormLocation: "component://kwikstore/widget/PartyForms.xml",
        columnFields: getFields("CustomerBillingPaymentMethods", PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerBillingPaymentMethods",PART_FORMS),
        //fieldFormFields:any,
        listType:"list",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"CustomerBillingPaymentMethods",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId,"paymentMethodTypeId":"CREDIT_CARD"},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"CustomerBillingPaymentMethods",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("CustomerBillingPaymentMethods",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("CustomerBillingPaymentMethods",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }



}
